import Cookies from 'js-cookie'
import {
  GQLConfig,
  GQLEstimatedDeliveriesType,
} from '~/graphql/__generated__/interfaces'
import { ShopConfig } from '~/module/shopConfig/shopConfigPlugin'

const EDE_ROLLOUT_COOKIE = 'ede_rollout_cookie'

export const setupEdeRolloutCookie = (
  getConfig: GQLConfig,
  shopConfig: ShopConfig
) => {
  if (process.client) {
    const edeRolloutPercent = getConfig.shopConfig.edeRolloutPercent
    const { isCookieSet } = shopConfig.abTests.cookies.edeRollout
    if (!isCookieSet) {
      const newValue =
        shopConfig.abTests.cookies.edeRollout.randomNumber < edeRolloutPercent
          ? '1'
          : '0'
      Cookies.set(EDE_ROLLOUT_COOKIE, newValue)
    }
  }
}

export const getEstimatedDeliveryType = (
  getConfig: GQLConfig,
  shopConfig: ShopConfig
): GQLEstimatedDeliveriesType => {
  if (process.client) {
    return Cookies.get(EDE_ROLLOUT_COOKIE) === '1'
      ? GQLEstimatedDeliveriesType.Ede
      : GQLEstimatedDeliveriesType.Eds
  } else if (shopConfig.abTests.cookies.edeRollout.isCookieSet) {
    return shopConfig.abTests.cookies.edeRollout.value
      ? GQLEstimatedDeliveriesType.Ede
      : GQLEstimatedDeliveriesType.Eds
  } else {
    return shopConfig.abTests.cookies.edeRollout.randomNumber <
      getConfig.shopConfig.edeRolloutPercent
      ? GQLEstimatedDeliveriesType.Ede
      : GQLEstimatedDeliveriesType.Eds
  }
}
